import React, { useEffect, useRef, useState } from 'react';
import { loadSmplrJs } from '@smplrspace/smplr-loader';
import { Box, Button } from '@mui/material';
import GetSites from './api/GetSites';
import { useParams } from 'react-router-dom';
import DataUnavailable from './data/DataUnavailable';
import SkySparkGrid from './api/SkySparkGrid';
import LoginCookieAuth from './api/LoginCookieAuth';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import Cookies from 'js-cookie';
import InfLoader from "../components/infLoad";

const ShowSpace = () => {
  const [viewerReady, setViewerReady] = useState(false);
  const { siteId } = useParams();
  const [spaceId, setSpaceId] = useState('');
  const [smplr, setSmplr] = useState()
  const [spaceCam, setSpaceCam] = useState({})
  const [spaceRefreshRate, setSpaceRefreshRate] = useState(10000)
  const [showSpace, setShowSpace] = useState(false)
  const [spaceLoading, setSpaceLoading] = useState(true)
  const [spaceMode, setSpaceMode] = useState('3d')
  const spaceRef = useRef();

  const SwitchSpaceMode = () => {
    if(spaceMode === '3d') setSpaceMode('2d')
    else setSpaceMode('3d')
  }

  // Load space
  useEffect(() => {
    if (!showSpace) {
      loadSmplrJs('EMS')
        .then((smplr) => {
          setSmplr(smplr);
        })
        .catch((error) => console.log(error))
    } else return
  },[showSpace])
  
  //Fetch space data
  useEffect(() => {
    LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(authResponse) => {
      if(authResponse) {
        setShowSpace(false)
        setSpaceLoading(true)
        const fetchData = async () => {
          try {
            const assetMap = await SkySparkGrid(`api_siteSmplrSpaceAssets(@${siteId})`);
            if(assetMap['data']['rows'].length === 0){
              setSpaceLoading(false)
              setShowSpace(false)
            } else {
              const response = await GetSites();
              const responseData = response.data; 
              const responseVal = responseData["rows"];
              responseVal.forEach((site) => {
                if (site.id.val === siteId) {
                  if (site.infSiteSmplrSpaceId) {
                    setSpaceId(site.infSiteSmplrSpaceId);
                    setSpaceCam(site.infSiteSmplrSpaceCameraPosition)
                    if(site.infSiteSmplrSpaceRefreshRate) setSpaceRefreshRate(site.infSiteSmplrSpaceRefreshRate)
                    setSpaceLoading(false)
                    setShowSpace(true)
                  } else {
                    setSpaceLoading(false)
                    setShowSpace(false)
                    if (spaceRef.current) spaceRef.current.remove()
                  }
                }
              }); 
            }
          } catch (error) {
            console.error(error);
          }
        }
        fetchData()
      }
    })
  }, [siteId, spaceMode]);

  // Setting space
  useEffect(() => {
    setViewerReady(false)
    if (smplr) {
      if (spaceRef.current) {
        spaceRef.current.remove();
      }
      if (showSpace) {
        spaceRef.current = new smplr.Space({
          spaceId: `${spaceId}`,
          clientToken: 'pub_3ee2a5233b354181a61c5e49691e7704',
          containerId: 'test',
        })
        spaceRef.current.startViewer({
          preview: false,
          loadingMessage:`${spaceMode.toUpperCase()} Weergave wordt gestart`,
          allowModeChange: true,
          mode: spaceMode,
          onReady: () => {
            console.log('Viewer ready')
            setViewerReady(true);
            if(spaceMode === '2d') spaceRef.current.centerCamera() 
          },
          onError: (e) => console.error('could not start viewer' + e),
          cameraPlacement: spaceCam,
          renderOptions: {
            floorplan: {
              render: true,
              alpha: 1,
              elevationInCm: 2
            }
          }
        })
      }
    }
  }, [smplr, spaceId, showSpace, spaceCam, spaceMode])

useEffect(() => {
  const yeet = async () => {
    try {
    if (!viewerReady) return;
    const assetMap = await SkySparkGrid(`api_siteSmplrSpaceAssets(@${siteId})`);
    const rows = assetMap["data"]["rows"];

    rows.forEach(level => {
      // For garage doors
      if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Roldeuren'){
        if (spaceRef.current.getDataLayer(level.id) !== undefined) {
          spaceRef.current.updateDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            color: (dataElement) => {
              try {
                if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                  let xAngle = parseInt(dataElement['curVal'].val)
                  if(xAngle < 80) {
                    return "#57d147";
                  } else {
                    return "#FF0000"
                  }
                } else {
                  return "#c7c7c7";
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            height: 4.3,
            alpha: 0.5
          })
        } else {
          spaceRef.current.addDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            color: (dataElement) => {
              try {
                if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                  let xAngle = parseInt(dataElement['curVal'].val)
                  if(xAngle < 80) {
                    return "#57d147";
                  } else {
                    return "#FF0000"
                  }
                } else {
                  return "#c7c7c7";
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            height: 4.3,
            alpha: 0.5
          })
        }
      }

      // For lights
      if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Lichtgroepen') {
        if (spaceRef.current.getDataLayer(level.id) !== undefined) {
          spaceRef.current.updateDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            color: (dataElement) => {
              try {
                if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                  let meetVal = parseInt(dataElement['curVal'].val)
                  if(meetVal > 10) {
                    return "#ffc90f";
                  } else {
                    return "#868686"
                  }
                } else {
                  return "#c7c7c7";
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            height: 4.3,
            alpha: 0.5
          })
        } else {
          spaceRef.current.addDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            color: (dataElement) => {
              try {
                if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                  let meetVal = parseInt(dataElement['curVal'].val)
                  if(meetVal > 10) {
                    return "#ffc90f";
                  } else {
                    return "#868686"
                  }
                } else {
                  return "#c7c7c7";
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            height: 4.3,
            alpha: 0.5
          }) 
        } 
      }
      // For building installations
      if (level.type === 'polygon' && spaceRef.current !== null && level.name === "Gebouwinstalaties"){
        if (spaceRef.current.getDataLayer(level.id) !== undefined) {
          spaceRef.current.updateDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            height: 3,
            color: (dataElement) => {
              try {
                if(dataElement['name'].includes("Storing decimaal cur") && dataElement['curVal'] !== undefined) {
                  let value = parseInt(dataElement['curVal'])
                  if(value > 5) {
                    return "#FF0000";
                  } else {
                    return "#57d147";
                  }
                } else if(dataElement['curValList'] !== undefined) {
                  if(dataElement['curValList'].find(row => row['unit'] === 'Pa') !== undefined) {
                    let value = parseInt(dataElement['curValList'].find(row => row['unit'] === 'Pa')['val'])
                    if(value > 20) {
                      return "#57d147";
                    } else {
                      return "#FF0000"
                    }
                  } else {
                    if(dataElement['curValList'][0]['val'] !== undefined) {
                      let value = parseInt(dataElement['curValList'][0]['val'])
                      if(value > 0) {
                        return "#57d147";
                      } else {
                        return "#FF0000"
                      }
                    } else {
                      let value = parseInt(dataElement['curValList'][0])
                      if(value > 0) {
                        return "#57d147";
                      } else {
                        return "#FF0000"
                      }
                    }
                  }
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            alpha: 0.5
          })
        } else {
          spaceRef.current.addDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            height: 3,
            color: (dataElement) => {
              try {
                if(dataElement['name'].includes("Storing decimaal cur") && dataElement['curVal'] !== undefined) {
                  let value = parseInt(dataElement['curVal'])
                  if(value > 5) {
                    return "#FF0000";
                  } else {
                    return "#57d147";
                  }
                } else if(dataElement['curValList'] !== undefined) {
                  if(dataElement['curValList'].find(row => row['unit'] === 'Pa') !== undefined) {
                    let value = parseInt(dataElement['curValList'].find(row => row['unit'] === 'Pa')['val'])
                    if(value > 20) {
                      return "#57d147";
                    } else {
                      return "#FF0000"
                    }
                  } else {
                    if(dataElement['curValList'][0]['val'] !== undefined) {
                      let value = parseInt(dataElement['curValList'][0]['val'])
                      if(value > 0) {
                        return "#57d147";
                      } else {
                        return "#FF0000"
                      }
                    } else {
                      let value = parseInt(dataElement['curValList'][0])
                      if(value > 0) {
                        return "#57d147";
                      } else {
                        return "#FF0000"
                      }
                    }
                  }
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            alpha: 0.5
          })
        }
      }
      // For normal rooms
      if (level.type === 'polygon' && spaceRef.current !== null && level.name !== 'Roldeuren' && level.name !== 'Lichtgroepen' && level.name !== "Gebouwinstalaties") {
        if (spaceRef.current.getDataLayer(level.id) !== undefined) {
          spaceRef.current.updateDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            color: (dataElement) => {
              try {
                if (dataElement.color) {
                  return dataElement.color;
                } else {
                  return "#c7c7c7";
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            alpha: 0.5
          });
        } else {
          spaceRef.current.addDataLayer({
            id: level.id,
            type: 'polygon',
            data: level.assets,
            tooltip: (d) => `${d.name}`,
            color: (dataElement) => {
              try {
                if (dataElement.color) {
                  return dataElement.color;
                } else {
                  return "#c7c7c7";
                }
              } catch (err) {
                console.log(`${dataElement?.id} cant be coloured`)
                return "#c7c7c7";
              }
            },
            alpha: 0.5
          });
        }
      }
    })
  } catch {
    return;
  }
  }
  yeet()
  const intervalId = setInterval(yeet, spaceRefreshRate); // Change time
  return () => clearInterval(intervalId);
}, [viewerReady, spaceRef, siteId, spaceMode, spaceRefreshRate]);

  return (
    <Box sx={{width:'100%', height:'100%'}}>
      {
        spaceLoading ? (
          <Box sx={{width:'100%', height:{ xl: '700px', lg: '500px', md: '400px' }, display:'flex', alignItems:'center', justifyContent:'center'}}>
            <InfLoader/>
          </Box>
        ) : (
          showSpace ? (
            <>
              <Button variant='contained' style={{backgroundColor:'#f2f0f0', color:'#141414', textTransform:'none', marginTop:'2px' }} startIcon={<ThreeDRotationIcon/>} onClick={() => SwitchSpaceMode()}>Verander weergave</Button>
              <Box id="test" sx={{ marginTop:'16px', height: { xl: '85vh', lg: '70vh', md: '60vh' }, width: { xl: '100%' } }}></Box>
            </> 
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                <DataUnavailable message='Geen 3D weergave beschikbaar voor deze locatie' />
              </Box>
            )
        )
      }
    </Box>
  )
}

export default ShowSpace;